import moment from "moment";

export const startMomentConfig = () => {
  moment.defaultFormat = "DD-MM-YYYY";
  moment.defaultFormatUtc = "DD-MM-YYYY";
};
